import { render, staticRenderFns } from "./accountActivities.vue?vue&type=template&id=0ece0f14&scoped=true&"
import script from "./accountActivities.vue?vue&type=script&lang=ts&"
export * from "./accountActivities.vue?vue&type=script&lang=ts&"
import style1 from "./accountActivities.vue?vue&type=style&index=1&id=0ece0f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece0f14",
  null
  
)

export default component.exports